export default {
  CidadesBuscarPorCep: "cidades/cep/{cep}",
  CidadesBuscarPorUF: "estados/{uf}",
  EstadosBusca: "estados/",
  EmpresasBusca: "empresas/",
  EmpresasId: (idEmpresa) => `empresas/id/${idEmpresa}`,
  EmpresaResponsavel: (idEmpresa) =>
    `empresas/${idEmpresa}/contato/responsavel`,
  EmpresaBuscaFiliais: (idEmpresaGrupo) => `/filiais/grupo/${idEmpresaGrupo}`,
  EmpresasBuscarPorCnpj: "empresas/cnpj/{cnpj}",
  EmpresasValidarCnpj: (cnpj) => `empresas/consultar-cnpj/${cnpj}`,
  RegionaisBusca: "regioes/",
  ModulosBusca: "modulos/",
  ModulosProdutos: "modulos/ciclo",
  PerfisBusca: "perfis/",
  CadastroEmpresa: "empresas/",
  AtualizaEmpresa: "empresas/{id}",
  DadosEmpresa: "empresas/{id}",
  GeneroBusca: "generos/",

  GruposBuscaPorModulo: "grupos/modulo/{idModulo}",
  GrupoDetalhe: "grupos/{grupo}/relacionamento/{relacionamento}",
  ResponsavelEmpresa: "empresas/{empresa}/responsavel/",
  EmpresaBuscarGrupoTipoPorId: "empresas/{id}/grupo-tipo",

  CadastroPessoa: "pessoa/",
  UpdatePessoa: "pessoa/{idColaborador}",

  BuscaDadosPessoa: "dados-colaborador/{colaborador}",
  BuscaPessoaCpf: "pessoa-por-cpf/{cpf}",
  ColaboradoresGrupo: "empresa-grupo/colaboradores",
  ColaboradorAtivaInativa: "empresa-grupo/colaborador/alterar-status/{idColaborador}",
  ColaboradoresEmpresaCiclo: "empresa/ciclo/colaboradores",
  PerfilBusca: "perfis/",
  EstadoCivilBusca: "estado-civil/",
  EscolaridadeBusca: "escolaridades/",
  RegimeBusca: "regimes/",
  TurnoBusca: "empresa-grupo/{grupo}/turnos-ativos",
  FuncaoBusca: "empresa-grupo/{grupo}/funcoes-ativas",
  SetorBusca: "empresa-grupo/{grupo}/setores-ativos",
  GerenciasBusca: "empresa-grupo/{grupo}/gerencias-ativas",
  DiretoriasBusca: "empresa-grupo/{grupo}/diretorias-ativas",
  UnidadeBusca: "empresa-grupo/{grupo}/unidades-ativas",
  EmpresaBusca: "empresas/grupo/{grupo}",
  LiderBusca: "empresa-grupo/empresa/lideres",
  BuscaPerfisColab: "perfis-colaborador/colaborador/{colaborador}",
  AlteraLoteColaboradorLider: "empresa-grupo/colaboradores/lider",

  BuscaParametrosTurno: "turnos/",
  BuscaVinculoTurno: "vinculo-turno/empresa-turno/{idEmpresaTurno}",
  EmpresaTurnoSemVinculo: "empresa-turno-sem-vinculo/empresa-grupo/{grupo}",
  CadastroEmpresaTurno: "empresa-turno/",
  UpdateEmpresaTurno: "/empresa-turno/{idEmpresaTurno}",
  BuscaEmpresaTurno: "empresa-turno/empresa-grupo/{grupo}",
  DeletaEmpresaTurno: "/empresa-turno/{idEmpresaTurno}",

  BuscaParametrosFuncao: "funcoes/",
  BuscaVinculoFuncao: "vinculo-funcao/empresa-funcao/{idEmpresaFuncao}",
  EmpresaFuncaoSemVinculo: "empresa-funcao-sem-vinculo/empresa-grupo/{grupo}",
  CadastroEmpresaFuncao: "empresa-funcao/",
  UpdateEmpresaFuncao: "/empresa-funcao/{idEmpresaFuncao}",
  BuscaEmpresaFuncao: "empresa-funcao/empresa-grupo/{grupo}",
  DeletaEmpresaFuncao: "/empresa-funcao/{idEmpresaFuncao}",

  CadastroEmpresaSetor: "empresa-setor/",
  UpdateEmpresaSetor: "/empresa-setor/{idEmpresaSetor}",
  BuscaEmpresaSetor: "empresa-setor/empresa-grupo/{grupo}",
  DeletaEmpresaSetor: "/empresa-setor/{idEmpresaSetor}",

  CadastroEmpresaUnidade: "empresa-unidade/",
  UpdateEmpresaUnidade: "/empresa-unidade/{idEmpresaUnidade}",
  BuscaEmpresaUnidade: "empresa-unidade/empresa-grupo/{grupo}",
  DeletaEmpresaUnidade: "/empresa-unidade/{idEmpresaUnidade}",

  CadastroEmpresaDiretoria: "empresa-diretoria/",
  UpdateEmpresaDiretoria: "/empresa-diretoria/{idEmpresaDiretoria}",
  BuscaEmpresaDiretoria: "empresa-diretoria/empresa-grupo/{grupo}",
  DeletaEmpresaDiretoria: "/empresa-diretoria/{idEmpresaDiretoria}",

  CadastroEmpresaGerencia: "empresa-gerencia/",
  UpdateEmpresaGerencia: "/empresa-gerencia/{idEmpresaGerencia}",
  BuscaEmpresaGerencia: "empresa-gerencia/empresa-grupo/{grupo}",
  DeletaEmpresaGerencia: "/empresa-gerencia/{idEmpresaGerencia}",

  ImportarPlanilhaColaboradores: "integracao/colaboradores",
  ImportarPlanilhaUsuarios: "integracao/usuarios",
  Login: "auth/login",
  LoginAdmin: "auth/login/admin",
  Logout: "auth/logout",
  EsqueceuSenha: "password/forgot",
  RedefinirSenha: "password/reset",
  RedefinirSenhaEmpresa: "password/redefinirUserEmpresa",

  TipoNotificacao: "notificacoes/tipo-notificacoes",
  FormaNotificacao: "notificacoes/forma-notificacoes",
  NotificacoesUsuario: "notificacoes-usuario",
  InsereNotificacoes: "notificacoes",
  FormaNotificacaoTipoNotificacao:
    "notificacoes/forma-notificacaoes-tipo-notificacoes",

  RetornaEmpresaGrupo: "/retorna-empresa-grupo/{idEmpresa}",

  FaqAjudas: "/ajudas",
  //Esperando demanda de Feature Flags (área desativada) - FaqAjudasEnviarEmailDuvida: "/ajuda/enviar-email-duvida",

  IntegracaoPlanilhaBuscarPorIdEmpresaGrupo:
    "/integracao/planilhas/grupo/{idEmpresaGrupo}",
  IntegracaoPlanilhaExportar: "/integracao/planilhas/exportar/{idPlanilha}",

  DadosMinhaConta: "dados-minha-conta",

  MeusDados: "meus-dados",

  RegrasUsuarioLogado: "/regras-usuario",

  BroadcastingAuth: "/broadcasting/auth",
  MinhasNotificacoesPendentes: "/notificacoes/minhas-notificacaoes/pendentes",
  MinhasNotificacoesAtualizar:
    "/notificacoes/minhas-notificacaoes/notificacao-usuario/{notificacaoUsuario}",


  EmpresasBuscarPorMatriz: "empresas/buscar/tipo/matriz",
  EmpresasBuscarPorFilial: "empresas/buscar/tipo/filial",

  UsuariosSesi: "usuarios/admin",
  UsuariosSesiAtualizar: (id) => `usuarios/admin/${id}`,

  ativarInativarEmpresa: (id) => `empresas/ativar-inativar/${id}`,

  ativarInativarUsuarioAdmin: "usuarios/admin/status/ativar-inativar",
  InterverStatusAtivoUsuarioEmpresa: "usuarios/inverter-status/empresa",

  AjudaSuporte: "ajuda",
  AjudaCategoria: "ajuda/categoria",

  Modulo: "modulo",
  ModuloEmpresa: "empresa/modulo/empresa-grupo/{idEmpresaGrupo}",
  ModuloAlteraStatus: "modulo/alterar-status",

  QuestoesPersonalizadas:
    "/empresa-grupo/modulo/questao-mensagem/personalizada",

  UpdateMensagem:
    "/empresa-grupo/{idEmpresaGrupo}/mensagem/{idMensagem}/personalizar",
  UpdateQuestao:
    "/empresa-grupo/{idEmpresaGrupo}/questao/{idQuestao}/personalizar",
  ResetarQuestoesPersonalizadas:
    "/empresa-grupo/modulo/questao-mensagem/resetar",


  OutrosProdutos: {
    getAndSaveProduct: "produto",
    changeProductRelevance: "produto/alterar-relevancia",
    getAndDeleteAndChangeStateUniqueProduct: (idProduct) =>
      `produto/${idProduct}`,
    editUniqueProduct: (idProduct) => `produto/${idProduct}?_method=PUT`,
  },

  BuscaEnderecoCep: (cep) => `/cep/${cep}`,
  BuscaCidadesUF: (uf) => `/cidades/uf/${uf}`,

  cadastroEmpresaMatriz: "/empresas/matriz",
  cadastroEmpresaFilial: "/empresas/filial",


  edicaoEmpresaMatriz: (idEmpresa) => `/empresas/matriz/${idEmpresa}`,
  edicaoEmpresaFilial: (idEmpresa) => `/empresas/filial/${idEmpresa}`,

  buscaEmpresaUsuario: "/empresas/usuario",

  LoginAuthVerify: "/auth/verify-login",
  changeCompany: (idEmpresa) => `/auth/troca-empresa/${idEmpresa}`,

  getInitialAccessPowerBIReportByModuleAndComponent: `/power-bi/relatorios`,
  getAccessPowerBIReport: `/power-bi/acesso-relatorio-embedded`,

}
